<template>
	<b-modal ref="modal" :title="`Edit sound for ${curUserEventType.event_name||curUserEventType.event_type}`" :busy="loading>0">
		<b-form @submit.stop.prevent="save()" id="userEventTypeEditForm">
			<div v-if="loading > 0">
				<b-form-group>
					<b-skeleton width="50%"/>
				</b-form-group>
				<b-form-row busy>
					<b-col>
						<b-form-group label="Sounds">
							<b-skeleton type="input"/>
						</b-form-group>
						<b-form-group label="Images">
							<b-skeleton type="input"/>
						</b-form-group>
					</b-col>
				</b-form-row>
			</div>
			<div v-else>
				<b-form-group :description="`Hide from ${curUserEventType.event_alert_type == 'alert' ? 'alert' : 'chat'} widget`" v-if="!['alert','default','chat'].includes(curUserEventType.event_type)">
					<b-form-checkbox switch v-model="curUserEventType.status" value="disabled" unchecked-value="enabled"> Disable {{curUserEventType.event_alert_type == 'alert' ? 'alert' : 'message'}}</b-form-checkbox>
				</b-form-group>
				<b-form-row v-if="curUserEventType?.status != 'disabled' || ['alert','default','chat'].includes(curUserEventType.event_type)">
					<b-col>
						<b-form-group label="Sounds">
							<pipi-pupu-multi-file v-model="curUserEventType.sounds" accept="audio/*"></pipi-pupu-multi-file>
						</b-form-group>
						<b-form-group label="Images" v-if="!['delete','clear','default','chat'].includes(curUserEventType.event_type)">
							<pipi-pupu-multi-file v-model="curUserEventType.images" accept="image/*"></pipi-pupu-multi-file>
						</b-form-group>
					</b-col>
				</b-form-row>
			</div>
		</b-form>
		<b-alert variant="danger" :show="!!error" class="mt-4 mb-0">{{error}}</b-alert>
		<template #modal-footer="{cancel}" :busy="loading>0">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button variant="success" type="submit" form="userEventTypeEditForm">Save</b-button>
			<b-button @click="cancel()">Close</b-button>
		</template>
	</b-modal>
</template>

<script>
import PipiPupuMultiFile from '../../../components/PipiPupuMultiFile.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		curUserEventType: {},
	}; },
	components: {
		PipiPupuMultiFile,
	},
	methods: {
		async show(messageType) {
			try {
				this.$refs.modal.show();
				this.loading++;
				this.error = null;
				this.curUserEventType = await this.$api.get(`userEventType/${messageType}`);
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}
		},
		async save() {
			try {
				this.loading++;
				this.error = null;
				await this.$api.post(`userEventType/${this.curUserEventType.event_type}`, {
					status: this.curUserEventType.status,
					sounds: (this.curUserEventType.sounds||[]).map(s => s.md5),
					images: (this.curUserEventType.images||[]).map(s => s.md5),
				});
				this.$refs.modal.hide();
				this.$emit('saved');
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}
		},
	}
}
</script>
